module.exports = __webpack_public_path__ + "img/default_logo.0d5d3766.png";